import { Outlet } from "react-router-dom";
import { useTheme } from "@/components/theme-provider";
import { Monitor, Sun, Moon } from "lucide-react";

function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const options = [
    { value: "system" as const, icon: Monitor },
    { value: "light" as const, icon: Sun },
    { value: "dark" as const, icon: Moon },
  ];

  return (
    <div className="flex items-center rounded-md border bg-muted/50 p-0.5">
      {options.map(({ value, icon: Icon }) => (
        <button
          key={value}
          onClick={() => setTheme(value)}
          className={`rounded-sm p-1 transition-colors ${
            theme === value
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          <Icon className="size-3.5" />
        </button>
      ))}
    </div>
  );
}

export default function Layout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Outlet />
      <div className="fixed bottom-4 right-4">
        <ThemeToggle />
      </div>
    </div>
  );
}
